module.exports = __webpack_public_path__ + "img/aidl.d18d3cf7.png";